<template>
    <div>
        <minhas-licitacoes-hoje :licitacoes="licitacoesHoje"/>
        <minhas-licitacoes-com-proposta/>
        <minhas-licitacoes-favoritas/>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import MinhasLicitacoesHoje from './MinhasLicitacoesHoje'
    import MinhasLicitacoesComProposta from './MinhasLicitacoesComProposta'
    import MinhasLicitacoesFavoritas from './MinhasLicitacoesFavoritas'

    export default {
        name: 'MinhasLicitacoes',
        components: {MinhasLicitacoesFavoritas, MinhasLicitacoesComProposta, MinhasLicitacoesHoje},
        data() {
            return {
                licitacoesHoje: []
            }
        },
        async mounted() {
            this.licitacoesHoje = await this.buscarLicitacoesFornecedorAcontecendoHoje()
        },
        methods: {
            ...mapActions([actionTypes.BUSCAR_LICITACOES_FORNECEDOR_ACONTECENDO_HOJE])
        }
    }
</script>